export enum SettingsTabsEnum {
  AUTHORISERS_MANAGEMENT = 1,
  UPLOAD_GUIDANCE = 2,
  FEATURED_AUTOMATIONS = 3,
}
